import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// local
// const firebaseConfig = {
//   apiKey: "AIzaSyC9fAfidUEU2vrIMJPiG8GidutBdJOpkuI",
//   authDomain: "sample-order-system.firebaseapp.com",
//   projectId: "sample-order-system",
//   storageBucket: "sample-order-system.firebasestorage.app",
//   messagingSenderId: "294729455261",
//   appId: "1:294729455261:web:fdbed339b47dc9eae9a674"
// };

//開発環境(dev) 
// const firebaseConfig = {
//   apiKey: "AIzaSyDEOC8XpxsbfGuEHIbmVRtLmA-STuc4jAI",
//   authDomain: "seko-sample-dev.firebaseapp.com",
//   projectId: "seko-sample-dev",
//   storageBucket: "seko-sample-dev.firebasestorage.app",
//   messagingSenderId: "1033497786824",
//   appId: "1:1033497786824:web:49d4043b031c1b24f468fd"
// };

// 本番環境(prod)
const firebaseConfig = {
  apiKey: "AIzaSyBFMYDxTpVrhm7bJoaDLLLMwDPruvNe-dI",
  authDomain: "seko-sample-prod.firebaseapp.com",
  projectId: "seko-sample-prod",
  storageBucket: "seko-sample-prod.firebasestorage.app",
  messagingSenderId: "381476618468",
  appId: "1:381476618468:web:5621a8a148b770226becf1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestoreインスタンスをエクスポート
export const db = getFirestore(app);
export const auth = getAuth(app);

// 【変更点】Firebaseのコアインスタンスをエクスポート
export default app;
